module.exports = __webpack_public_path__ + "media/images/static/guide/cover-ac96f85da5a3ef5665b3e25cae05e1c3.png";